import React from 'react'
import SuccessForm from '../success-form/success-form'

const Success = () => {
  return <SuccessForm />
}


export default Success